import { t, Trans } from '@lingui/macro'
import { Paper, Typography } from '@material-ui/core'
import { css } from 'emotion'
import React, { useState } from 'react'
import { Redirect } from 'react-router'

import { CenterContainer } from '../atoms/CenterContainer'
import { useRoot } from '../atoms/RootProvider'
import { SuccessText } from '../atoms/SuccessText'
import { useSnackBar } from '../hooks/useSnackBar'
import { i18n } from '../i18n'
import { LoginForm } from '../molecules/LoginForm'
import { GuestLayout } from '../organisms/GuestLayout'

const paper = css`
  position: fixed;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 10rem;
  top: 30%;
  padding: 1rem;
`

enum EResult {
  INIT,
  SENDING,
  SENT,
  INVALID,
}

export const LoginPage: React.FC = () => {
  const { auth } = useRoot()
  const [result, setResult] = useState(EResult.INIT)
  const { enqueueError } = useSnackBar()

  const onSubmit = async (email: string) => {
    setResult(EResult.SENDING)
    try {
      await auth.login(email)
      setResult(EResult.SENT)
    } catch (err) {
      enqueueError(`${err.message} (${err.code})`)
      setResult(EResult.INVALID)
    }
  }

  if (auth.isAuthenticated) {
    return <Redirect to="/" />
  }

  return (
    <GuestLayout title={i18n._(t`Přihlášení`)}>
      <CenterContainer>
        <Paper className={paper}>
          <Typography gutterBottom>
            <Trans>
              Pošleme Vám email s odkazem kterým se přihlásíte do aplikace.
            </Trans>
          </Typography>
          <LoginForm
            onSubmit={onSubmit}
            buttonText={
              result === EResult.SENT
                ? i18n._(t`Email odeslán`)
                : i18n._(t`Odeslat email`)
            }
            disabled={result === EResult.SENDING || result === EResult.SENT}
            emailInvalid={result === EResult.INVALID}
          />
        </Paper>
        {result === EResult.SENT && (
          <SuccessText variant="h4">
            <br />
            <Trans>Toto okno můžete nyní zavřít a použít odkaz z emailu.</Trans>
          </SuccessText>
        )}
      </CenterContainer>
    </GuestLayout>
  )
}
